export default __webpack_public_path__ + "static/media/flower-boy.0288025d.jpg";